import { ClrCommonStrings } from "@clr/angular";

export const Spanish: Partial<ClrCommonStrings> = {
    showColumns:'Mostrar columnas',
    selectAll:'Seleccionar todo',
    pickColumns:'Administrar columnas',
  };